import { render, staticRenderFns } from "./help-icon.vue?vue&type=template&id=3d452de3&scoped=true"
import script from "./help-icon.vue?vue&type=script&lang=js"
export * from "./help-icon.vue?vue&type=script&lang=js"
import style0 from "./help-icon.vue?vue&type=style&index=0&id=3d452de3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d452de3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d452de3')) {
      api.createRecord('3d452de3', component.options)
    } else {
      api.reload('3d452de3', component.options)
    }
    module.hot.accept("./help-icon.vue?vue&type=template&id=3d452de3&scoped=true", function () {
      api.rerender('3d452de3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/help-icon/help-icon.vue"
export default component.exports